// AuthButton — bronze primary + charcoal secondary variants.
export default function AuthButton({
  children, variant = "bronze", loading = false, disabled = false, testid, ...rest
}) {
  const isBronze = variant === "bronze";
  const bg = disabled || loading ? "#4a3f2a" : (isBronze ? "#C9A86A" : "#2a2a2a");
  const color = isBronze ? "#0f0f0f" : "#f7f7f7";
  return (
    <button
      {...rest}
      data-testid={testid}
      disabled={disabled || loading}
      className="w-full py-2.5 text-sm font-semibold rounded-md transition-opacity"
      style={{
        background: bg,
        color,
        letterSpacing: "0.5px",
        opacity: disabled || loading ? 0.7 : 1,
        cursor: disabled || loading ? "not-allowed" : "pointer",
        border: isBronze ? "none" : "1px solid #3a3a3a",
      }}
    >{loading ? "Please wait…" : children}</button>
  );
}
